export default __webpack_public_path__ + "static/ink-art-refer-5d6c75b7069fe241617ef579dfb6132c.svg";